import MemoList from "../MemoList";

export default function Secretary() {
  return <MemoList memoType="Secretary" buttonNew={true} />;
}
